<template>
    <div class="MMyExam">
        <div @click="toQuesDetails" class="ques_info_box">
            <img class="img" v-lazy="quesInfoData.coverurl" alt="">
            <p>{{quesInfoData.assetname}}</p>
        </div>
        <pull :pull="pull" :page="page" @getList="getList">
            <!-- <NoData v-if="!dataList.length"></NoData> -->
            <div v-if="!dataList.length" class="noData_box">
                <img class="img" :src="require('common/images/mobile/img-noData.png')" alt="">
                <span>当前暂无考试记录</span>
                <p @click="toQuesDetails">立即前往考试></p>
            </div>
            <div class="my_exam_warp">
                <div v-for="(item, index) in dataList" :key="index" class="my_exam_item_box">
                    <div>
                        <div class="top_div">
                            <div class="van-multi-ellipsis--l2 title_box">{{item.taskname}}</div>
                            <div class="exam_info_box">
                                <span>答题时长 {{item.factexamtime}}分钟</span>
                            </div>
                        </div>
                        <div class="bottom_div">
                            <span v-if="item.status === 10" class="green_text">{{item.examtotalscore}}分</span>
                            <span v-if="item.status === 1" class="red_text">未完成</span>
                            <span v-if="item.status === 9" class="yellow_text">待批阅</span>
                            <div class="btn_box">
                                <div @click="ToTest(item)" v-show="item.ismakeuptest === 1" class="btn_div btn_again">重新考试</div>
                                <div @click="ContinueTest(item)" v-show="item.status === 1" class="btn_div">继续考试</div>
                                <div @click="SeeResults(item)" v-show="item.status === 10 || item.status === 9" class="btn_div">查看成绩</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </pull>
    </div>
</template>

<script>
import {getUserDoExamRecordList} from 'api/examApi'
import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'
// import NoData from 'views/mobile/components/noData/noData'
import Pull from 'views/mobile/components/pull/pull'
export default {
    name: 'MMyQuestion',
    data() {
        return {
            quesInfoData: {},
            // testImg: 'http://innertest.img.capwhale.com/kmc/content/20200211/4ac47838ea9b41219d765b65e23241c4',
            init: false,
            dataList: [],
            param: {
                bankid: ''
            },
            page: {
                page: 1,
                pageSize: 10,
                pageCount: 0,
                rowCount: 0
            },
            pull: {
                isLoading: false,
                loading: false,
                error: false,
                finished: false
            }
        }
    },
    mounted() {
        this.setNoDataTip('暂无考试记录')
        if (!this.refresh) {
            this.param.bankid = this.$route.query.bankid
            this.goTop()
            this.getList()
        }
    },
    activated () {
        if (this.refresh) {
            this.param.bankid = this.$route.query.bankid
            this.getList()
            this.goTop()
            this.setRefresh(false)
        }
    },
    methods: {
        // 回到顶部
        goTop() {
            // $('#coursedetailswarp').animate({scrollTop:'0'},500)
            $("html,body").animate({
                scrollTop: 0
            }, 200)
        },
        // 跳转到题库详情
        toQuesDetails() {
            this.setRefresh(true)
            this.$router.push({name: 'PaperDetails', query: {qid: this.quesInfoData.bankid}})
        },
        // 重新考试
        ToTest(val) {
            this.setRefresh(true)
            this.$router.push({name: 'PaperInfo',query: {bankid: val.bankid, taskid: val.taskinnerid}})
        },
        // 继续考试
        ContinueTest(val) {
            this.setRefresh(true)
            this.$router.push({name: 'PaperInfo',query: {bankid: val.bankid, taskid: val.taskinnerid}})
        },
        // 查看成绩
        SeeResults(val) {
            // console.log(val)
            this.setRefresh(true)
            this.$router.push({name: 'MExamResult',query: {exampid: val.innerid}})
        },
        // 点击我的考试单个考试进入考试信息页面
        handExamClick(val) {
            // console.log(val)
            this.setRefresh(true)
            // this.$router.push({name: 'MExamResult', query: {exampid: val.exampaperinnerid}})
            this.$router.push({name: 'PaperInfo',query: {bankid: val.bankid, taskid: val.taskinnerid}})
        },
        // 获取考试列表
        getList() {
            this.setLoading(true)
            getUserDoExamRecordList({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.init = true
                    if (this.page.page === 1) {
                        this.quesInfoData = data.data
                        this.pull.isLoading = false
                        this.dataList = data.data.content
                    } else {
                        this.dataList = this.dataList.concat(data.data.content)
                    }
                    this.setLoading(false)
                    this.pull.loading = false
                    this.page.pageCount = data.data.pageinfo.pageCount
                    this.page.rowCount = data.data.pageinfo.rowCount
                    if (this.page.page === this.page.pageCount) {
                        this.pull.finished = true
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.pull.error = true
                    this.pull.loading = false
                    this.$toast.fail(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setRefresh',
            'setNoDataTip'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['refresh'])
    },
    components: {
        // NoData,
        Pull
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.3s
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active, 2.1.8 版本以下 */ {
        opacity: 0
    }
    .MMyExam {
        font-family:PingFangSC-Regular,PingFang SC;
        background:rgba(245,247,250,1);
        min-height: 100vh;
        color: #333;
        display: flex;
        flex-direction: column;
        .ques_info_box {
            background: #fff;
            display: flex;
            padding: 0.32rem;
            margin-bottom: 0.2rem;
            &>img{
                background-color: #eee;
                width: 2.6rem;
                min-width: 2.6rem;
                height: 1.46rem;
                min-height: 1.46rem;
                border-radius: 0.04rem;
                margin-right: 0.18rem;
            }
            &>p {
                font-size: 0.28rem;
                line-height:0.4rem;
                color:rgba(51,51,51,1);
            }
        }
        .noData_box{
            // height: 100vh;
            min-height: calc(100vh - 2.1rem);
            background: #fff;
            display: flex;
            flex-direction: column;
            align-items: center;
            // justify-content: center;
            &>img {
                margin-top: 2.6rem;
                width: 1.69rem;
                height: 1.63rem;
            }
            &>span, &>p {
                margin: 0.2rem 0;
                color: #999;
                font-size: 0.26rem;
                line-height: 0.4rem;
            }
            &>p{
                margin: 0;
                color: #409EFF;
            }
        }
        .van-pull-refresh {
            min-height: 60vh;
        }
        .my_exam_warp {
            // min-height: calc(100vh - 2.1rem);
            .my_exam_item_box {
                // padding: 0.32rem 0;
                margin-bottom: 0.2rem;
                background-color: rgb(255, 255, 255);
                &>div{
                    padding: 0 0.32rem;
                    .top_div {
                        border-bottom: 0.01rem solid #E5E5E5;
                        flex: 1;
                        padding: 0.32rem 0;
                        .title_box {
                            font-size: 0.28rem;
                            line-height: 0.4rem;
                            text-align: justify;
                        }
                        .exam_info_box {
                            margin-top: 0.16rem;
                            &>span {
                                font-size: 0.24rem;
                                line-height: 0.34rem;
                                color: #999;
                            }
                        }
                    }
                    .bottom_div {
                        height: 0.78rem;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        &>span {
                            font-size: 0.24rem;
                            line-height: 0.34rem;
                            color: #999;
                        }
                        .green_text {
                            color: #0ABF53;
                        }
                        .red_text {
                            color: #F56C6C;
                        }
                        .yellow_text {
                            color: #FFA904;
                        }
                        .btn_box {
                            display: flex;
                            .btn_div {
                                font-size: 0.24rem;
                                width: 1.3rem;
                                height: 0.46rem;
                                line-height: 0.46rem;
                                text-align: center;
                                border-radius: 0.23rem;
                                background-color: #409EFF;
                                color: #FFF;
                                box-sizing: border-box;
                            }
                            .btn_div + .btn_div {
                                margin-left: 0.2rem;
                            }
                            .btn_again {
                                background-color: #fff;
                                color: #C0C4CC;
                                border: 0.01rem solid #C0C4CC;
                            }
                        }
                    }
                }
            }
            .my_exam_item_box:nth-last-of-type(1) {
                border-bottom: none;
            }
        }
    }
</style>